module.exports = __webpack_public_path__ + "static/media/agenda.f7f9215f.png";